<template>
  <div class="ExerciseAnalysis">
    <!--    整体作答-->
    <div class="summary">
      <div class="content_title">
        <i class="icon icon-shu"></i>
        整体作答情况
      </div>
      <el-table
        :border="true"
        header-row-class-name="tableHeader"
        :data="exerciseData.AllSummary"
      >
        <el-table-column prop="TotalQuestionNum" label="题目总数">
        </el-table-column>
        <el-table-column prop="TotalAnswersNum" label="完成人数">
        </el-table-column>
        <el-table-column label="总人数">
          <template slot-scope="scope">
            {{ studentList.length }}
          </template>
        </el-table-column>

        <el-table-column label="正确率">
          <template slot-scope="scope">
            {{
              parseInt(scope.row.Accuracy * 100) === scope.row.Accuracy * 100
                ? scope.row.Accuracy * 100
                : (scope.row.Accuracy * 100).toFixed(1)
            }}%
          </template>
        </el-table-column>
        <el-table-column label="平均用时">
          <template slot-scope="scope">
            {{
              Math.floor(scope.row.AvgDuration / 60) +
              "分" +
              parseInt(scope.row.AvgDuration % 60) +
              "秒"
            }}
          </template>
        </el-table-column>
        <el-table-column label="最快用时">
          <template slot-scope="scope">
            {{
              Math.floor(scope.row.QuickDuration / 60) +
              "分" +
              (scope.row.QuickDuration % 60).toFixed(0) +
              "秒"
            }}
          </template>
        </el-table-column>
        <el-table-column label="最慢用时">
          <template slot-scope="scope">
            {{
              Math.floor(scope.row.SlowDuration / 60) +
              "分" +
              parseInt(scope.row.SlowDuration % 60) +
              "秒"
            }}
          </template>
        </el-table-column>
        <el-table-column label="正确率人数">
          <el-table-column
            prop="Accuracy100_90"
            label="[100%-90%]"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="Accuracy90_80"
            label="(90%-80%]"
            min-width="100"
          >
          </el-table-column>
          <el-table-column
            prop="Accuracy80_60"
            label="(80%-60%]"
            min-width="100"
          >
          </el-table-column>
          <el-table-column prop="Accuracy60" label="(60%-0%]" min-width="100">
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <!--    各题作答-->
    <div>
      <div class="content_title">
        <i class="icon icon-shu"></i>
        各题作答情况
      </div>
      <div class="questions">
        <div class="questionsLeft">
          <div class="move moveBottom">
            <el-button
              @click="moveQuestion(1)"
              type="primary"
              icon="el-icon-arrow-up"
            >
            </el-button>
          </div>
          <div class="questionList">
            <ul id="questionListUl" :style="{ top: ulTop + 'px' }">
              <li
                v-for="(item, i) of exerciseData.QuestionImgs"
                :key="i"
                @click="changeQuestion(item, i)"
                :class="{ active: i === selQuestion }"
              >
                <img :src="item.ImgPath" alt="" />
              </li>
            </ul>
          </div>
          <div class="move moveTop">
            <el-button
              @click="moveQuestion(-1)"
              type="primary"
              icon="el-icon-arrow-down"
            ></el-button>
          </div>
        </div>
        <div class="questionsMiddle">
          <div class="questionsMiddleTop">
            <div class="questionDetail">
              <img
                v-if="exerciseData.QuestionImgs.length > 0"
                @click="popImgShow = !popImgShow"
                :src="exerciseData.QuestionImgs[selQuestion].ImgPath"
              />
              <div class="replaceImg">
                <el-upload
                  ref="replaceImg"
                  :data="upReplaceImg"
                  :on-success="replaceImgSucessBack"
                  accept="image/*"
                  title="替换题目截图"
                  :show-file-list="false"
                  :action="myurl + 'send_questionpic'"
                >
                  <i class="el-icon-upload"></i>
                </el-upload>
              </div>
            </div>
          </div>
          <div class="questionsMiddleBottom" v-show="isObjective">
            <div id="answerGroupChart"></div>
          </div>
        </div>
        <div class="questionsRight">
          <div class="questionAnalysis">
            <table>
              <tr>
                <td class="th">题号</td>
                <td>
                  <div v-if="SingleSummary.length > 0">
                    {{ SingleSummary[0].QuestionNo }}
                  </div>
                </td>
              </tr>
              <tr>
                <td class="th">正确率</td>
                <td>
                  <div v-if="SingleSummary.length > 0">
                    {{ (SingleSummary[0].Accuracy * 100).toFixed(1) }}%
                  </div>
                </td>
              </tr>
              <tr>
                <td class="th">平均用时</td>
                <td>
                  <div v-if="SingleSummary.length > 0">
                    {{ SingleSummary[0].AvgDuration.toFixed(0) }}秒
                  </div>
                </td>
              </tr>
              <tr>
                <td class="th">最快用时</td>
                <td>
                  <div v-if="SingleSummary.length > 0">
                    {{ SingleSummary[0].QuickDuration.toFixed(0) }}秒
                  </div>
                </td>
              </tr>
              <tr>
                <td class="th">最慢用时</td>
                <td>
                  <div v-if="SingleSummary.length > 0">
                    {{ SingleSummary[0].SlowDuration.toFixed(0) }}秒
                  </div>
                </td>
              </tr>
              <tr>
                <td class="th">答题总人数</td>
                <td>
                  <div v-if="SingleSummary.length > 0">
                    {{ SingleSummary[0].SumPeople }}人
                  </div>
                </td>
              </tr>
              <tr>
                <td class="th">答对人数</td>
                <td>
                  <div v-if="SingleSummary.length > 0">
                    {{ SingleSummary[0].CorrectPeople }}人
                  </div>
                </td>
              </tr>
              <tr>
                <td class="th">答错人数</td>
                <td>
                  <div v-if="SingleSummary.length > 0">
                    {{ SingleSummary[0].WrongPeople }}人
                  </div>
                </td>
              </tr>
              <tr v-if="isObjective">
                <td class="th">正确答案</td>
                <td>
                  <div v-if="SingleSummary.length > 0">
                    {{ SingleSummary[0].StandAnswer | formatAnswer }}
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <div class="botTable">
            <el-table
              ref="studentAnswerTable"
              height="400px"
              :border="true"
              :stripe="true"
              :highlight-current-row="true"
              header-row-class-name="tableHeader"
              cell-class-name="cell"
              @sort-change="answerSort"
              :data="StudentAnswers"
            >
              <el-table-column
                width="90"
                sortable="custom"
                prop="StudentName"
                :filters="studentNameFilter"
                :filter-method="filterStudentName"
                label="学生"
              >
              </el-table-column>
              <el-table-column
                v-if="isObjective"
                :filters="answerFilter"
                :filter-method="filterAnswer"
                prop="answer"
                label="答案"
              >
                <template slot-scope="scope">
                  {{ scope.row.answer | formatAnswer }}
                </template>
              </el-table-column>
              <el-table-column
                sortable
                :filters="correctFilter"
                :filter-method="filterCorrect"
                :formatter="rightFormatter"
                label="批阅"
              >
                <!-- <template slot-scope="scope">
                  <div>
                    {{scope.row.AnswerID ? (scope.row.Correct | correctF) : ''}}
                  </div>
                </template> -->
              </el-table-column>
              <el-table-column width="80" label="用时">
                <template slot-scope="scope" v-if="scope.row.AnswerID > 0">
                  {{ scope.row.duration.toFixed(0) }}秒
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!--    学生作答情况-->
    <div class="answerDetail">
      <div class="content_title">
        <i class="icon icon-shu"></i>
        学生作答情况
      </div>
      <el-table
        :border="true"
        :data="studentList"
        header-row-class-name="tableHeader"
      >
        <el-table-column prop="StudentName" label="学生姓名"> </el-table-column>
        <el-table-column prop="TotalMinutes" label="答题总用时">
        </el-table-column>
        <el-table-column prop="Average" label="答题平均用时"> </el-table-column>
        <el-table-column prop="Correct" label="正确题数"> </el-table-column>
        <el-table-column prop="Error" label="错误题数"> </el-table-column>
        <el-table-column prop="ErrorEate" label="错题率"> </el-table-column>
        <el-table-column type="index" width="60" label="排名">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="answerDetail(scope)" type="text"
              >详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="popImg" v-show="popImgShow" @click="popImgShow = !popImgShow">
      <img
        v-if="exerciseData.QuestionImgs.length > 0"
        :src="exerciseData.QuestionImgs[selQuestion].ImgPath"
      />
    </div>
  </div>
</template>

<script>
import EchartTheam from "./../../assets/js/echartTheam.json";
// import * as Echart from "echarts";
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
let color = [
  "#658FFF",
  "#b04aff",
  "#3AB679",
  "#eed538",
  "#a379a8",
  "#0ae617",
  "#EE8344",
  "#EE75C0",
  "#2BA8B6",
  "#7466EE",
  "#62B682",
  "#15EEBF",
  "#FF740F",
  "#1009EE",
  "#EE05B7",
  "#EE0312",
];
export default {
  name: "ExerciseAnalysis",
  props: {
    exerciseData: {
      type: Object,
      default: [],
    },
    studentList: {
      type: Array,
    },
    lessonId: {
      type: [Number, String],
    },
    resizeNum: { type: [String, Number] },
  },
  data() {
    return {
      popImgShow: false,
      popImgSrc: "",
      selQuestion: 0,
      isObjective: true, //是否客观题.
      questionListUL: null,
      ulTop: 0, // 当前移动的距离.
      topHeight: 54, //每次移动的距离.
      //图表
      AnswerGroups: [],
      //图表
      answerEchart: null,
      option: {
        grid: {
          left: "30px",
          right: "0px",
          bottom: "25px",
          top: "30px",
        },
        // legend: {
        //   data: ['第九题选择答案人数统计'],
        //   top: 15,
        // },
        tooltip: {
          show: true,
        },
        xAxis: {
          data: ["A", "C", "D"],
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              color: "#f5f5f5",
            },
          },
          minInterval: 1,
        },
        series: [
          {
            name: "第九题选择答案人数统计",
            type: "bar",
            data: [
              {
                value: 58,
                itemStyle: { color: "#f00" },
              },
              23,
              9,
            ],
            label: {
              show: true,
              position: "top",
              // formatter: '选择{b}︰共{c}人',
              fontSize: 12,
              fontWeight: "bolder",
            },
          },
        ],
      },
      myurl: window.url,
      //变动的值.
      StudentAnswers: [],
      // StudentAnswersCopy:'',//存数据的json
      // StudentAnswersSort:true,
      filterAnswers: [],
      SingleSummary: [],
      upReplaceImg: {
        text: "",
      },

      // 作答结果 {0:'错误',1:'正确',-1:"未批"}
      studentNameFilter: [],
      answerFilter: [],
      //filterAnswer:[],
      correctFilter: [
        { text: "错误", value: 0 },
        { text: "正确", value: 1 },
        { text: "未批", value: -1 },
        { text: "", value: "" },
      ],
      eParam: "",
    };
  },
  created(){
    echarts.registerTheme("roma", EchartTheam);

  },
  mounted() {
    this.questionListUL = document.getElementById("questionListUl");
    this.init();
  },
  methods: {
    //切换题目数据变更.
    changeQuestion(question, i) {
      this.selQuestion = i;

      this.$refs.studentAnswerTable.clearSort();
      this.$refs.studentAnswerTable.clearFilter();
      this.upReplaceImg.text = JSON.stringify({
        questionID: question.QuestionId,
      });
      this.isObjective = question.QuestionType !== 4;
      this.studentNameFilter = [];
      this.answerFilter = [];
      this.StudentAnswers = [];
      this.axios
        .get(
          window.url +
            `GetPracAnalysisSingle?QuestionID=${question.QuestionId}&lessionId=${this.lessonId}`
        )
        .then((res) => {
          this.SingleSummary = res.data.data.SingleSummary;
          //保存下全局的
          this.exerciseData.StudentAnswers = res.data.data.StudentAnswers;
          this.StudentAnswers = JSON.parse(
            JSON.stringify(res.data.data.StudentAnswers)
          );
          //this.StudentAnswersCopy=JSON.stringify(this.exerciseData.StudentAnswers);

          this.StudentAnswers.forEach((item) => {
            this.studentNameFilter.push({
              text: item.StudentName,
              value: item.StudentName,
            });
            let index = -1;
            for (let i = 0; i < this.answerFilter.length; i++) {
              if (this.answerFilter[i].value === item.answer) {
                index = i;
                break;
              }
            }
            let answerText = "";
            let answerValue = item.answer;
            if (item.answer != null && item.answer.length > 0) {
              switch (question.QuestionType) {
                case 1:
                case 2:
                  answerText = item.answer;
                  break;
                case 3:
                  answerText =
                    item.answer == "T" || item.answer === "t" ? "对" : "错";
                  break;
              }
            }

            if (index < 0) {
              this.answerFilter.push({
                text: answerText,
                value: answerValue,
              });
            }
          });
          let xData = [],
            sData = [];
          res.data.data.AnswerGroups.forEach((item, i) => {
            if (item.answer === "T" || item.answer === "t") {
              xData.push("对");
            } else if (item.answer === "F" || item.answer === "f") {
              xData.push("错");
            } else {
              xData.push(item.answer);
            }
            sData.push({
              value: item.Num,
              itemStyle: { color: color[i] },
            });
          });
          this.option.xAxis.data = xData;
          this.option.series[0].data = sData;
          this.option.series[0].name = `第${i + 1}题选择答案人数统计`;
          // this.option.legend.data[0]=`第${i+1}题选择答案人数统计`;
          this.answerEchart.setOption(this.option, true);
        });
    },
    moveQuestion(i) {
      let ulHeight = parseFloat(getComputedStyle(this.questionListUL).height);
      let ulParentHeight = parseFloat(
        getComputedStyle(this.questionListUL.parentElement).height
      );

      if (ulHeight + this.ulTop > 108 * 6 && i < 0) {
        this.ulTop += i * this.topHeight;
      }
      if (this.ulTop < 0 && i > 0) {
        this.ulTop += i * this.topHeight;
      }
    },
    init() {
      this.ulTop = 0;
      this.StudentAnswers = JSON.parse(
        JSON.stringify(this.exerciseData.StudentAnswers)
      );
      //this.StudentAnswersCopy=JSON.stringify(this.exerciseData.StudentAnswers);
      this.studentNameFilter = [];
      this.answerFilter = [];
      this.StudentAnswers.forEach((item) => {
        this.studentNameFilter.push({
          text: item.StudentName,
          value: item.StudentName,
        });
        let index = -1;
        for (let i = 0; i < this.answerFilter.length; i++) {
          if (this.answerFilter[i].text === item.answer) {
            index = i;
            break;
          }
        }
        if (index < 0) {
          this.answerFilter.push({
            text: item.answer,
            value: item.answer,
          });
        }
      });
      this.SingleSummary = this.exerciseData.SingleSummary;
      if (this.exerciseData.QuestionImgs.length > 0) {
        this.upReplaceImg.text = JSON.stringify({
          questionID: this.exerciseData.QuestionImgs[0].QuestionId,
        });
        this.isObjective = this.exerciseData.QuestionImgs[0].QuestionType !== 4;
      }
      let answerGroupChart = document.querySelector(".questionsMiddleBottom");
      let answerWidth = getComputedStyle(answerGroupChart).width;
      answerGroupChart.setAttribute(
        "style",
        `width:${answerWidth};height:272px`
      );
      let xData = [],
        sData = [];
      this.exerciseData.AnswerGroups.forEach((item, i) => {
        //xData.push(item.answer);
        if (item.answer === "T" || item.answer === "t") {
          xData.push("对");
        } else if (item.answer === "F" || item.answer === "f") {
          xData.push("错");
        } else {
          xData.push(item.answer);
        }
        sData.push({
          value: item.Num,
          itemStyle: { color: color[i] },
        });
      });
      this.option.xAxis.data = xData;
      this.option.series[0].data = sData;
      this.option.series[0].name = "第1题选择答案人数统计";
      // this.option.legend.data[0]="第1题选择答案人数统计";
      if (!this.answerEchart) {
        // 随机练习分析柱状图
        this.answerEchart = echarts.init(answerGroupChart, "roma");
      }
      this.answerEchart.setOption(this.option);
      let that = this;
      this.answerEchart.on("click", (params) => {
        // let newStudentAnswer = this.exerciseData.StudentAnswers.filter((item, i) => {
        //   if (item.answer === params.name) return true;
        // });
        // this.StudentAnswers = newStudentAnswer;
        that.eParam = params.name;
      });
    },
    reDrawEchart(i) {
      this.StudentAnswers = JSON.parse(
        JSON.stringify(this.exerciseData.StudentAnswers)
      );
      // this.StudentAnswersCopy=JSON.stringify(this.exerciseData.StudentAnswers);
      this.SingleSummary = this.exerciseData.SingleSummary;
      if (this.exerciseData.QuestionImgs.length > 0) {
        this.upReplaceImg.text = JSON.stringify({
          questionID: this.exerciseData.QuestionImgs[0].QuestionId,
        });
        this.isObjective = this.exerciseData.QuestionImgs[0].QuestionType !== 4;
      }
      let xData = [],
        sData = [];
      this.exerciseData.AnswerGroups.forEach((item, i) => {
        //xData.push(item.answer);
        if (item.answer === "T" || item.answer === "t") {
          xData.push("对");
        } else if (item.answer === "F" || item.answer === "f") {
          xData.push("错");
        } else {
          xData.push(item.answer);
        }
        sData.push({
          value: item.Num,
          itemStyle: { color: color[i] },
        });
      });
      this.option.xAxis.data = xData;
      this.option.series[0].data = sData;
      this.option.series[0].name = `第${i}题选择答案人数统计`;
      // this.option.legend.data[0]=`第${i}题选择答案人数统计`;
      this.answerEchart.setOption(this.option, true);
    },
    // 答题详情
    answerDetail(scope) {
      window.onresize = null;
      // this.$router.replace(
      //   {
      //     name: 'Student',
      //     query: {lessonID: this.lessonId, StudentID: scope.row.StudentID},
      //     params: {studentList: this.studentList, activeStudentIndex: scope.$index}
      //   }
      // );
      sessionStorage["params"] = JSON.stringify({
        studentList: this.studentList,
        activeStudentIndex: scope.$index,
      });
      const { href } = this.$router.resolve({
        name: "Student",
        query: { lessonID: this.lessonId, StudentID: scope.row.StudentID },
      });
      window.open(href);
    },
    replaceImgSucessBack(res, file, files) {
      if (res.result === 200) {
        this.exerciseData.QuestionImgs[this.selQuestion].ImgPath = res.data;
      } else {
        this.$alert(file.name + "上传失败,请重新上传", "提示");
      }
    },
    //表格排序
    answerSort(column) {
      if (!column.order) {
        // this.StudentAnswers=JSON.parse(this.StudentAnswersCopy);
        this.StudentAnswers = JSON.parse(
          JSON.stringify(this.exerciseData.StudentAnswers)
        );
      } else {
        switch (column.column.label) {
          case "学生":
            if (column.order === "ascending") {
              this.StudentAnswers.sort((a, b) => {
                let str1 = a.StudentName.substr(0, 1);
                let str2 = b.StudentName.substr(0, 1);
                return str1.localeCompare(str2);
              });
            } else if (column.order === "descending") {
              this.StudentAnswers.sort((a, b) => {
                let str1 = a.StudentName.substr(0, 1);
                let str2 = b.StudentName.substr(0, 1);
                return str2.localeCompare(str1);
              });
            }
            break;
          case "批阅":
            if (column.order === "ascending") {
              this.StudentAnswers.sort((a, b) => {
                return b.Correct - a.Correct;
              });
            } else if (column.order === "descending") {
              this.StudentAnswers.sort((a, b) => {
                return a.Correct - b.Correct;
              });
            }
        }
      }
    },
    //表格过滤
    // 1.学生姓名过滤
    filterStudentName(value, row, column) {
      //console.log("arguments",arguments);
      return value == row.StudentName;
    },
    // //2,学生答案过滤,预留.
    filterAnswer(value, row, column) {
      // console.log("filterAnswer**********");
      // console.log(value);
      // console.log(row);
      return value === row.answer;
    },
    // 2.作答结果过滤
    filterCorrect(value, row, column) {
      // console.log("filterCorrect**********");
      // console.log(value);
      // console.log(row);
      if (value === "") {
        return row.AnswerID == 0;
      } else {
        let correct = row.Correct == null ? -1 : row.Correct;
        console.log(correct);
        return row.AnswerID > 0 && value == correct;
      }
    },
    rightFormatter(row, column) {
      if (row.AnswerID > 0) {
        if (row.Correct === 1) {
          return "正确";
        } else if (row.Correct === 0) {
          return "错误";
        } else {
          return "未批";
        }
      } else {
        return "";
      }
    },
    // 4.还原通过图表筛选的答案.
    restoreStudentAnswer() {
      this.StudentAnswers = JSON.parse(
        JSON.stringify(this.exerciseData.StudentAnswers)
      );
    },
  },
  watch: {
    exerciseData(val, oldVal) {
      this.selQuestion = 0;
      this.reDrawEchart(1);
      this.init();
    },
    eParam(val, oldVal) {
      let column = this.$refs.studentAnswerTable.columns[1];
      column.filteredValue = [val];
      this.$refs.studentAnswerTable.store.commit("filterChange", {
        column,
        values: column.filteredValue,
        silent: true,
      });
    },
    resizeNum(val, oldVal) {
      let questionsMiddleTop = document.querySelector(".questionsMiddleTop");
      let answerWidth = getComputedStyle(questionsMiddleTop).width;
      let answerGroupChart = document.querySelector(".questionsMiddleBottom");
      answerGroupChart.setAttribute(
        "style",
        `width:${answerWidth};height:272px`
      );
      this.answerEchart.resize();
    },
  },
  filters: {
    correctF(val) {
      if (val === 1) {
        return "正确";
      } else if (val === 0) {
        return "错误";
      } else {
        return "未批";
      }
    },
    formatAnswer(val) {
      switch (val) {
        case "t":
        case "T":
          return "对";
        case "f":
        case "F":
          return "错";
        default:
          return val;
      }
    },
  },
};
</script>

<style scoped lang="less">
.ExerciseAnalysis {
  box-sizing: border-box;

  /deep/ .tableHeader {
    background: #f6f6f6;
    th {
      background: #f6f6f6;
      color: #2c3e50;
      &.gutter {
      }
    }
  }

  .content_title {
    background-color: #ffffff;
    margin-bottom: 10px;
    text-align: left;
    padding-left: 30px;
    font-size: 16px;
    font-weight: 600;
    /*position: fixed;*/
    position: relative;

    .icon-shu {
      position: absolute;
      left: 0px;
      font-size: 24px;
      background: #59bf85;
      border-radius: 2px;
      width: 5px;
      height: 16px;
      margin: 0px 5px;
      display: inline-block;
    }
  }

  //整体作答情部
  .summary {
    margin-top: 20px;
    margin-bottom: 20px;

    /deep/ .el-table td {
      padding: 8px 0;
    }
  }

  //各题作答情况
  .questions {
    display: flex;

    .questionsLeft {
      width: 140px;
      min-width: 96px;
      overflow: hidden;

      .move {
        height: 21px;

        .el-button {
          padding: 0;
          width: 100%;
          font-size: 20px;
          border: 0;
          margin: 0;
          line-height: 20px;
        }

        &.moveTop {
          .el-button {
            border-radius: 0 0 100px 100px;
          }
        }

        &.moveBottom {
          .el-button {
            border-radius: 100px 100px 0 0;
          }
        }
      }

      .questionList {
        overflow: hidden;
        border: 1px solid #f0f0f0;
        height: 648px;
        position: relative;

        ul {
          top: 0;
          position: absolute;

          li {
            padding: 0;
            margin: 0;
            width: 100%;
            box-sizing: border-box;
            overflow: hidden;

            img {
              max-width: 100%;
            }

            &.active {
              border: 3px solid #f00;
            }
          }
        }
      }
    }

    .questionsMiddle {
      overflow: hidden;
      flex: 1 1 auto;
      margin: 0 10px;

      .questionsMiddleTop {
        display: flex;
        height: 420px;
        margin-bottom: 10px;

        .questionDetail {
          flex: 1 1 auto;
          padding: 0 10px;
          position: relative;

          img {
            max-height: 100%;
            width: 100%;
          }

          .replaceImg {
            position: absolute;
            bottom: 8px;
            right: 18px;
            background: rgba(0, 0, 0, 0.6);
            color: #fff;
            border-radius: 100px;
            width: 40px;
            height: 40px;
            line-height: 38px;
            font-size: 30px;
          }
        }
      }

      .questionsMiddleBottom {
        height: 272px;
      }
    }

    .questionsRight {
      width: 360px;
      /*min-width: 340px;*/
      /*max-width: 340px;*/

      /deep/ .cell {
        height: 34px;
        line-height: 34px;
      }

      .questionAnalysis {
        width: 360px;
        min-width: 360px;
        margin-bottom: 12px;

        table {
          border-collapse: collapse;

          tr {
            td {
              padding: 5px 0;
              width: 200px;
              border: 1px solid #ebeef5;

              &.th {
                background: #f6f6f6;
                color: #2c3e50;
                width: 200px;
              }
            }
          }
        }
      }
      /deep/ .botTable > .el-table {
        .el-table__header-wrapper {
          table {
            padding-right: 17px;
            background: #f4f4f4;
            /*border-bottom: 1px solid #B0B7C2;*/
            /*border-collapse:collapse;*/
          }
        }
      }
    }
  }

  //各学生作答情况
  .answerDetail {
    /deep/ .el-table td {
      padding: 5px 0;
    }
  }

  /deep/ .el-table td {
    padding: 0;
  }

  .popImg {
    position: fixed;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.7);

    left: 0;
    right: 0;
    bottom: 0;
    top: 0;

    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      max-height: 100%;
      max-width: 100%;
    }
  }

  .el-dropdown {
    padding: 0;
    color: #2c3e50;
    font-size: 14px;
    line-height: 34px;

    /deep/ .el-icon-arrow-down {
      font-size: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail/ExerciseAnalysis.vue